import React ,{useEffect} from 'react';
import clsx from 'clsx';
import RowElement from "../../../../DataElements/RowElement";
import {
    NameTextField
} from '../../../../../../styling/Styles';
import RadioMechanism from '../../../../../GeneralComponents/RadioMechanism';

//  This component returns a row inside the edit window of list data element.Every row contains an image a title and a description
const EditListComponent = (props) => {
    const {
      index,
      componentsInfo,
      setComponentsInfo,
      componentsIds,
      setComponentsIds,
      initListElement,
      setInitListElement,
      clickedEdit,
      deleteComps,
      setDeleteComps,
      edited,
      setEdited
    } = props;
    
    const [displayContent, setDisplayContent] = React.useState(false);
    const [imageSource, setImageSource] = React.useState('');
    const [titleText, setTitleText] = React.useState('');
    const [descriptionText, setDescriptionText] = React.useState('');
    const [hrefChecked, setHrefChecked] = React.useState(false)
    const [targetPageChecked, setTargetPageChecked] = React.useState(false);
    const [href, setHref] = React.useState('');
    const [target, setTarget] = React.useState('none');
    const [targets, setTargets] = React.useState()
    
    /*
    This useEffect is used to initiate information about a row inside an edited list data element.
    It renders when opens the edit pop up window (var initListElement.
    */
    useEffect( () => {
        if(initListElement === true ){
            setTitleText(componentsInfo[index].info.titleText);
            setDescriptionText(componentsInfo[index].info.descriptionText);
            setImageSource(componentsInfo[index].info.imageSrc);
            if(componentsInfo[index].info.targetPage !== 'undefined' && componentsInfo[index].info.targetPage !== ''){
                setTarget(componentsInfo[index].info.targetPage);
                setTargetPageChecked(true);
                setHref('');
            }
            else{
                setTarget('none');
                setTargetPageChecked(false);
            }
            if(componentsInfo[index].info.href !== ''  && componentsInfo[index].info.href !== undefined  ){
                setHref(componentsInfo[index].info.href);
                setHrefChecked(true);
                setTarget('none');
            }
            else if(componentsInfo[index].info.targetPage === 'undefined' || componentsInfo[index].info.targetPage === ''){
                setHrefChecked(true);
                setTarget('none');
            }
            else{
                setHrefChecked(false);
            }
            
            setInitListElement(false);

            const selectedProject = localStorage.getItem('selectedProject');
            const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject];
            const tempTargets = [];
            tempData.pages.forEach( (page) => {
                tempTargets.push(page.name);
            })
            setTargets(tempTargets);
        }
    },[initListElement,clickedEdit])

    /*
    This useEffect is runned every time that a new row inside a list is added or deleted. It is used to render correctly the info
    of every row.
    */
    useEffect(() => {
        if(edited === true){
            setTitleText(componentsInfo[index].info.titleText);
            setDescriptionText(componentsInfo[index].info.descriptionText);
            setImageSource(componentsInfo[index].imageSrc);

            const tempComponentsInfo = [...componentsInfo];
            if(componentsInfo[index].info.hrefChecked === true && componentsInfo[index].info.targetPageChecked === true){
                if(componentsInfo[index].info.targetPage !== '' && componentsInfo[index].info.targetPage !== 'undefined'){
                    tempComponentsInfo[index].info.hrefChecked = false;
                    tempComponentsInfo[index].info.href = '';
                    setComponentsInfo(tempComponentsInfo);
                    setHref('');
                    setHrefChecked(false);
                }
                else{
                    tempComponentsInfo[index].info.targetPageChecked = false;
                    tempComponentsInfo[index].info.targetPage = 'undefined';
                    setComponentsInfo(tempComponentsInfo);
                    setTarget('none');
                    setTargetPageChecked(false);
                }
            }
            else{
                if(componentsInfo[index].info.targetPageChecked === false && componentsInfo[index].info.hrefChecked === false){
                    setTargetPageChecked(true)
                    setHrefChecked(false);
                }
                else{
                    setHrefChecked(componentsInfo[index].info.hrefChecked);
                    setTargetPageChecked(componentsInfo[index].info.targetPageChecked);
                }
                setHref(componentsInfo[index].info.href);
                if(componentsInfo[index].info.targetPage === '' || componentsInfo[index].info.targetPage === 'undefined'){
                    setTarget('none')
                }
                else{
                    setTarget(componentsInfo[index].info.targetPage);
                }
            } 
            setEdited(false);
            const selectedProject = localStorage.getItem('selectedProject');
            const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject];
            const tempTargets = [];
            tempData.pages.forEach( (page) => {
                tempTargets.push(page.name);
            })
            setTargets(tempTargets);
        }
    },[edited])
    

    /* 
    This function deletes the row component of the edited list data element window and of the information about the block that we keep 
    and renders again. It keeps  the id of the row so as to delete it later from  canvas grapesJs when update button is clicked.
    */ 
    const deleteElement = () =>{
        
        const tempDeleteComps = [...deleteComps];
        tempDeleteComps.push(componentsIds[index].rowId);
        setDeleteComps(tempDeleteComps);

        const tempComponentsInfo = [...componentsInfo];
        tempComponentsInfo.splice(index,1);
        setComponentsInfo(tempComponentsInfo);

        const tempComponentsIds = [...componentsIds];
        tempComponentsIds.splice(index,1);
        setComponentsIds(tempComponentsIds);

        setEdited(true);

    }

    /*
    This function change the value of image source of the image component that exists in a row of an edited data element type of list.
    It changes the value in the edit list pop up window and stores the value to use it if we want to generate a block. It stores the new 
    value src to update the component image when update button is pressed.
    */
    const handleImageSource = (val) => {
        
        const tempComponentsInfo = [...componentsInfo];
        tempComponentsInfo[index].info.imageSrc = val.target.value;
        setComponentsInfo(tempComponentsInfo);

        setImageSource(val.target.value);
        
    }
  
    /*
    This function change the value of text of the title component that exists in a row of an edited data element type of list.
    It changes the value  in the edit list pop up window and stores the value to use it if we want to generate a block. It stores the new 
    value title text to update the component title when update button is pressed.
    */
    const handleTitleText = (val) => {
       
        setTitleText(val.target.value);

        const tempComponentsInfo = [...componentsInfo];
        tempComponentsInfo[index].info.titleText = val.target.value;
        setComponentsInfo(tempComponentsInfo);
        
    }
   
    /*
    This function change the value of text of the description component that exists in a row of an edited data element type of list.
    It changes the value in the edit list pop up window and stores the value to use it if we want to generate a block.It stores the new 
    value description text to update the component description when update button is pressed.
    */
    const handleDescriptionText = (val) => {

        setDescriptionText(val.target.value);

        const tempComponentsInfo = [...componentsInfo];
        tempComponentsInfo[index].info.descriptionText = val.target.value;
        setComponentsInfo(tempComponentsInfo);

    }
    
    /*
    This function controls the radio button of href of image component inside the edit list pop up window.If it is clicked then it 
    disables the radio button of target page, it passes the value of href as an attribute to the componentsInfo var so as to update
    the component later,  it clears the value of target page inside the componentsInfo var and stores the state of href radio button 
    inside the componentsInfo var to use it if we want to generate a block.
    */
    const handleHrefChecked = () => {
       
    
        const tempComponentsInfo = [...componentsInfo];
        if(hrefChecked === false){
            setHrefChecked(true);
            setTargetPageChecked(false);
            
            tempComponentsInfo[index].info.hrefChecked = true;
            tempComponentsInfo[index].info.targetPageChecked = false;
            tempComponentsInfo[index].info.href = href;
            tempComponentsInfo[index].info.targetPage = '';
        }
        else{
            setHrefChecked(false);
            tempComponentsInfo[index].info.hrefChecked = false;
        }
        setComponentsInfo(tempComponentsInfo);
        
    }
  
    /*
    This function controls the radio button of target page of image component inside the edit list pop up window.If it is clicked then it 
    disables the radio button of href, it passes the value of target page as an attribute to the componentsInfo var so as to update
    the component later,  it clears the value of href inside the componentsInfo var and stores the state of target page radio button 
    inside the componentsInfo var to use it if we want to generate a block.
    */
    const handleTargetPageChecked = () => {
        
    
        const tempComponentsInfo = [...componentsInfo];
        if(targetPageChecked === false){
            setTargetPageChecked(true);
            setHrefChecked(false);
            tempComponentsInfo[index].info.targetPageChecked = true;
            tempComponentsInfo[index].info.hrefChecked = false;
            tempComponentsInfo[index].info.href = '';
            tempComponentsInfo[index].info.targetPage = target;
        }
        else{
            setTargetPageChecked(false);
            tempComponentsInfo[index].info.targetPageChecked = false;
        }
        setComponentsInfo(tempComponentsInfo);        
    }
  
    /*
    This function changes the value of href var. It stores the value of href inside componentsInfo var clears the target page var inside
    componentsInfo var and updates the hrefChecked and targetPageChecked vars inside componentsInfo var so as to update the row component
    and the inside components when update button is pressed or to use the vars to generate a block.
    */ 
    const handleHref = (val) => {
        
        setHref(val.target.value);
        const tempComponentsInfo = [...componentsInfo];
        tempComponentsInfo[index].info.href = val.target.value;
        tempComponentsInfo[index].info.targetPage = 'undefined';
        tempComponentsInfo[index].info.hrefChecked = true;
        tempComponentsInfo[index].info.targetPageChecked = false;
        setHrefChecked(true);
        setTargetPageChecked(false);
    
        setComponentsInfo(tempComponentsInfo);
    }
  
    /*
    This function changes the value of target page var. It stores the value of target page inside componentsInfo var clears the href var inside
    componentsInfo var and updates the hrefChecked and targetPageChecked vars inside componentsInfo var so as to update the row component
    and the inside components when update button is pressed or to use the vars to generate a block.
    */
    const selectTarget = (option) => {

        const tempComponentsInfo = [...componentsInfo];
        
        setTarget(option);
        componentsInfo[index].info.targetPage = option;
        componentsInfo[index].info.href = '';
        componentsInfo[index].info.targetPageChecked = true;
        componentsInfo[index].info.hrefChecked = false;
        setTargetPageChecked(true);
        setHrefChecked(false);
        setComponentsInfo(tempComponentsInfo);
    }

    return(
        <>  
           <div style={{marginTop: '1vw'}}>

            <RowElement
                label= {`List element ${index+1}`}
                displayContent={displayContent}
                setDisplayContent={setDisplayContent}
                deleteElement={deleteElement}

            />
          </div>
          <div className={clsx('spacingTopDiv', 'spacingLeftDiv')} style={displayContent !== true ? {display: 'none'}: {display: 'inherit'} }>
            <div className={clsx('spacingLeftDiv','spacingTopDiv')}>
              <div>
                  Image source: &nbsp; <span style={{display: 'inline-block', marginLeft: '4vw' }}/>
                  <NameTextField
                      placeholder=' Image source'
                      onInput={e =>handleImageSource(e)}
                      value={imageSource}
                  />
              </div>
            </div>
            <div className={clsx('spacingLeftDiv')}>
                <RadioMechanism 
                    hrefChecked={hrefChecked}
                    handleHrefChecked={handleHrefChecked}
                    handleHref={handleHref}
                    href={href}
                    targetPageChecked={targetPageChecked}
                    handleTargetPageChecked={handleTargetPageChecked}
                    target={target}
                    targets={targets}
                    selectTarget={selectTarget}
                    isEditList = 'true'
                />
            </div>
            
            <div className={clsx('spacingLeftDiv','spacingTopDiv')}>
              <div>
                  Title text: &nbsp; <span style={{display: 'inline-block', marginLeft: '6.5vw' }}/>
                  <NameTextField
                      placeholder=' Title text'
                      onInput={e =>handleTitleText(e)}
                      value={titleText}
                  />
              </div>
            </div>
            <div className={clsx('spacingLeftDiv','spacingTopDiv')}>
              <div>
                  Description text: &nbsp; <span style={{display: 'inline-block', marginLeft: '3.2vw' }}/>
                  <NameTextField
                          
                          placeholder= ' Description Text'
                          onInput={e => handleDescriptionText(e)}
                          value={descriptionText}
                          multiline
                          rows={3}
                  /> 
              </div>
            </div>
          </div>
            
        </>
    )

}

export default EditListComponent;